/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { collectionToStories } from "@quintype/components";
import { CollectionName } from "../../Atoms/CollectionName";
import { StateProvider } from "../../SharedContext";
import { getTextColor, getNumberOfStoriesToShow } from "../../../utils/utils";
import { StoryCard } from "../../Molecules/StoryCard";
import { HeroImage } from "../../Atoms/HeroImage";
import { StorycardContent } from "../../Molecules/StorycardContent";
import PropTypes from "prop-types";
import { LoadmoreButton } from "../../Atoms/Loadmore";
import { GlideCarousel } from "../../Glide/glide";
import "./4-story-slider.m.css";
import "../../../../assets/stylesheets/glide.scss";

const FourStorySlider = ({ collection, config = {} }) => {
  const {
    collectionNameBorderColor = "",
    borderColor = "",
    theme = "",
    border = "",
    collectionNameTemplate = "",
    autoplaySpeed,
    numberOfStoriesToShow = 0,
    footerButton = "",
    footerSlotConfig = {}
  } = config;
  const { footerSlot } = footerSlotConfig;
  const items = collectionToStories(collection);
  if (items.length < 1) {
    return null;
  }
  const options = {
    autoplay: autoplaySpeed,
    perView: 4,
    gap: 24,
    breakpoints: {
      767: { perView: 1 }
    }
  };
  const showNumberOfStoriesToShow = getNumberOfStoriesToShow(numberOfStoriesToShow);
  const textColor = getTextColor(theme);
  const footerSlotComp = footerSlot ? footerSlot() : null;
  return (
    <div className="full-width-with-padding arrow-component" style={{ backgroundColor: theme, color: textColor }}>
      <div styleName="four-story-slider-wrapper">
        <CollectionName
          collection={collection}
          collectionNameTemplate={collectionNameTemplate}
          collectionNameBorderColor={collectionNameBorderColor}
        />
        <GlideCarousel {...options}>
          {items.slice(0, showNumberOfStoriesToShow).map((story, index) => {
            return (
              <StoryCard story={story} theme={theme} border={border} key={index}>
                <HeroImage story={story} aspectRatio={[[16, 9]]} />
                <StorycardContent story={story} border={border} borderColor={borderColor} />
              </StoryCard>
            );
          })}
        </GlideCarousel>
        <LoadmoreButton collection={collection} template={footerButton} />
        {footerSlotComp}
      </div>
    </div>
  );
};

FourStorySlider.propTypes = {
  /**  collection is the array of objects which is returning by API  */
  collection: PropTypes.object.isRequired,
  /** The config for the Row */
  config: PropTypes.shape({
    // section tag border color
    borderColor: PropTypes.string,
    //   background color of the row
    theme: PropTypes.string,
    border: PropTypes.string,
    footerButton: PropTypes.string,
    // configure ad slot widget and story
    collectionNameTemplate: PropTypes.string,
    autoplaySpeed: PropTypes.number,
    // speed of the slider(ms)
    numberOfStoriesToShow: PropTypes.number,
    // no of slides in slider
    collectionNameBorderColor: PropTypes.string
  })
};

FourStorySlider.defaultProps = {
  theme: "#ffffff",
  slotConfig: "story",
  border: ""
};

export default StateProvider(FourStorySlider);
